import type { CreatureReachFoldInput, CreatureReachFoldResult, CreatureReachSource } from '../types';

/** Cap equipped reach provenance, sum the source ledger, and zero-elide the cluster. */
export function foldCreatureReachSources(input: CreatureReachFoldInput): CreatureReachFoldResult {
    const sources: CreatureReachSource[] = input.sources.map(source => ({ ...source }));
    const inventoryIndexes: number[] = [];
    for (let index = 0; index < sources.length; index += 1) {
        if (sources[index]?.kind === 'inventory_equipped') inventoryIndexes.push(index);
    }

    if (inventoryIndexes.length > 1) {
        let winnerIndex = inventoryIndexes[0] ?? 0;
        let winnerValue = sources[winnerIndex]?.value ?? 0;
        for (const index of inventoryIndexes.slice(1)) {
            const value = sources[index]?.value ?? 0;
            if (value > winnerValue) {
                winnerValue = value;
                winnerIndex = index;
            }
        }
        for (const index of inventoryIndexes) {
            if (index === winnerIndex) continue;
            const source = sources[index];
            if (!source) continue;
            sources[index] = { ...source, value: 0, raw_value: source.value, suppressed: true };
        }
    }

    const total = sources.reduce((sum, source) => sum + source.value, 0);
    return total === 0 ? null : { total, base: input.sizeReach, sources };
}
